import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { getPlaces } from '../../services/placesService';
import {
  editingPlaceState,
  loadingPlacesState,
  placesPageState,
  placesState,
  searchPlaceState,
  selectedPlaceIdState,
  updatePlacesState,
} from '../../storage/places';
import { Place } from '../../types/place';
import { PaginatedProvider } from './PaginatedProvider';

export function PlacesProvider() {
  const updatePlaces = useRecoilValue(updatePlacesState);
  const resetUpdatePlaces = useResetRecoilState(updatePlacesState);
  const resetEditingPlace = useResetRecoilState(editingPlaceState);
  const setPaginatedPlaces = useSetRecoilState(placesState);
  const setLoadingPlaces = useSetRecoilState(loadingPlacesState);
  const resetSelectedPlaceId = useResetRecoilState(selectedPlaceIdState);

  return (
    <PaginatedProvider<Place>
      searchState={searchPlaceState}
      pageState={placesPageState}
      getPaginated={getPlaces}
      setPaginated={setPaginatedPlaces}
      onSearchChange={resetSelectedPlaceId}
      onUpdateFinish={() => {
        resetUpdatePlaces();
        resetEditingPlace();
      }}
      setLoading={setLoadingPlaces}
      update={updatePlaces}
    />
  );
}
